import React from "react";

export default function Footer() {
  return (
    <div className=''>
      <div class="bg-black text-white">
        <footer class="container p-5">
          <div class="row">
            <div class="col-sm-auto mb-3 text-center d-sm-none mb-5">
              <a
                class="btn btn-social footer-button "
                href="https://www.facebook.com/mdisopen"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="fa fa-facebook text-white"></span>
              </a>
              <a
                class="btn btn-social ml-2 footer-button"
                href="https://www.instagram.com/mdisopen"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="fa fa-instagram text-white"></span>
              </a>
              <a
                class="btn btn-social ml-2 footer-button"
                href="https://www.linkedin.com/company/induswam"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="fa fa-linkedin-square text-white"></span>
              </a>
            </div>
            <div class="col mb-2 small text-center d-sm-none">
              © 2021, IndusWam. All rights reserved
            </div>
            <div class="col mb-2 d-none d-sm-block">
              © 2021, IndusWam. All rights reserved
            </div>
            <div class="col-sm-auto text-center d-none d-sm-block">
              <a
                class="btn btn-social footer-button"
                href="https://www.facebook.com/mdisopen"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="fa fa-facebook text-white"></span>
              </a>
              <a
                class="btn btn-social ml-2 footer-button"
                href="https://www.instagram.com/mdisopen"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="fa fa-instagram text-white"></span>
              </a>
              <a
                class="btn btn-social ml-2 footer-button"
                href="https://www.linkedin.com/company/induswam"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="fa fa-linkedin-square text-white"></span>
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
